/**
*
* useDefaultRecipientsTab
*
*/

import useStorage from 'utils/storage/useStorage.js';
import useRecipientRoles from './useRecipientRoles.js';

function useDefaultRecipientsTab() {
  const roles = useRecipientRoles();
  const [roleId, setRoleId] = useStorage('conversationsRecipientsTab', roles[0].id);
  if (roles.some((role) => role.id === roleId)) {
    return [roleId, setRoleId];
  }
  return [roles[0].id, setRoleId];
}

export default useDefaultRecipientsTab;
